import { getQueryImmediateStrategyV1, getPopOpenedV1, getPresale } from '@/api/goods';
import { env, ISession, ILocalStorage } from '@utils';
const promptStorageKey = 'mallCourseProptShowTime';
const actions = {
  // 获取紧迫性组件信息
  async acGetQueryImmediateStrategyData({ dispatch, commit, state, rootState, rootGetters }, { goodsId }) {
    let res = null;
    if (!goodsId) {
      dispatch('acSetQueryImmediateStrategyData', { data: {}, goodsId });
      return {};
    }
    try {
      res = await getQueryImmediateStrategyV1({ goodsId });
      dispatch('acSetQueryImmediateStrategyData', { data: res.data, goodsId });
    } catch (error) {
      dispatch('acSetQueryImmediateStrategyData', { data: {}, goodsId });
    }
    return res.data;
  },
  // 设置当前紧迫性组件数据
  acSetQueryImmediateStrategyData({ dispatch, commit }, { data, goodsId }) {
    let { isLogin, sellJson = {}, payJson = {}, beginTime } = data || {};
    beginTime && (beginTime = beginTime.replace(/-/g, '/'));
    commit('muSetIsLogin', isLogin);
    // 先根据后台返回数据设置是否展示挽留提示
    commit('muSetShowPrompt', {
      isShowSell: sellJson?.popup,
      isShowPay: payJson?.popup,
    });
    // 非登陆状态使用本地缓存的时间戳来判断是否展示挽留提示
    if (!isLogin) {
      dispatch('acSetPromptShowTime');
    }

    const { bottom } = sellJson;
    const { top } = payJson;
    // 设置计时器数据
    dispatch('acSetCountDown', { bottom, top, beginTime });
    // 设置剩余名额
    dispatch('acSetCourseQuota', { bottom, top, goodsId });
    // 设置手机号滚动
    commit('muSetPhoneRoll', sellJson?.isPhoneRoll);
    // 保存所有数据
    commit('muSetImmediateStrategyData', data);
  },

  // 非登陆状态使用本地缓存的时间戳来判断是否展示挽留提示
  acSetPromptShowTime({ commit, state, rootState, rootGetters }, params) {
    let promptShowTime = ILocalStorage(promptStorageKey) || 0;
    const showTime = (new Date()).getTime();
    if (!promptShowTime || showTime - promptShowTime > 24 * 60 * 60 * 1000) {
      // promptShowTime 不存在 或是 超过24小时，则更具是否有数据进行展示
      promptShowTime = showTime;
    } else {
      commit('muSetShowPrompt', {
        isShowSell: false,
        isShowPay: false,
      });
    }
  },
  // 重置本地缓存的showTime
  acResetPromptShowTime({ dispatch, commit, state, rootState, rootGetters }, params = {}) {
    const { showTime = (new Date()).getTime() } = params;
    commit('muSetPromptShowTime', showTime);
    ILocalStorage(promptStorageKey, showTime);
    dispatch('acSetPromptShowTime');
  },
  // 设置计时器数据
  acSetCountDown({ dispatch, commit, state, rootState, rootGetters }, { bottom, top, beginTime }) {
    let sellDuring = 0, payDuring = 0, sd = 0, pd = 0;
    const nowTime = (new Date()).getTime();
    const bTime = (new Date(beginTime)).getTime();
    const d = (nowTime - bTime) || 0;   // 已过时间
    if (bottom) {
      sellDuring = (bottom.hour * 3600 + bottom.minute * 60 + bottom.second * 1) * 1000;
      if (d < sellDuring) {
        sd = sellDuring - d;
      } else {
        let remainder = d % sellDuring;
        sd = sellDuring - remainder;
      }
    }
    if (top) {
      payDuring = (top.minute * 60 + top.second * 1) * 1000;
      if (d < payDuring) {
        pd = payDuring - d;
      } else {
        let remainder = d % payDuring;
        pd = payDuring - remainder;
      }
    }
    commit('muSetCountDown', {
      isSellCount: bottom,
      isPayCount: top,
      sellDate: sd,
      payDate: pd,
      sellDuring,
      payDuring
    });
  },
  // 保存剩余名额
  acSetCourseQuota({ dispatch, commit, state, rootState, rootGetters }, { bottom = {}, top = {} }) {
    const { sellCountDownDuring, payCountDownDuring, sellDuring, payDuring } = state;
    const sellNum = bottom && bottom.initNum * (sellCountDownDuring / sellDuring) || 0;
    const payNum = top && top.initNum * (payCountDownDuring / payDuring) || 0;
    // 售卖页面与支付页面的剩余名额要显示一直
    let showNum = sellNum || payNum;
    commit('muSetCourseQuota', Math.ceil(showNum));
  },
  // 登陆时标记挽留弹窗
  acSetPopOpenedV1({ dispatch, commit, state, rootState, rootGetters }) {
    getPopOpenedV1();
  },

  // 查询商品预售信息
  async acGetPresale({ dispatch, commit, state, rootState, rootGetters }, data = []) {
    if (!data || !data.length) {
      return;
    }
    let res = await Promise.all([dispatch('acGetServerTime', null, { root: true }), getPresale(data)]);
    let [serverDate, preSaleData] = res;
    if (preSaleData.data && preSaleData.data.length) {
      let { begintime, endtime } = preSaleData.data[0];
      begintime = begintime.replace(/T/g, ' ').replace(/-/g, '/');
      endtime = endtime.replace(/T/g, ' ').replace(/-/g, '/');
      const bt = new Date(begintime).getTime();
      const et = new Date(endtime).getTime();
      const tamp = new Date().getTime() - serverDate.subStamp;
      if (tamp > bt && tamp <= et) {
        preSaleData.data[0].isPreSaleDuring = true;
      }
    }
    commit('muSetPreSave', preSaleData.data[0] ? preSaleData.data[0] : null);
    return res;
  },
};
export default actions;
